export const PertinentSectionKey = {
    VisitsAndProcedures: 'visits_and_procedures',
    ATCNote: 'atc_note_summary',
    CardiacAndVascular: 'cardiac_and_vascular',
    Malignancy: 'malignancy',
    DialysisAndRenal: 'dialysis_and_renal',
    ChronicMedicalConditions: 'chronic_medical_conditions',
    SpecialMedications: 'special_medications',
    Neurological: 'neurological',
    SignificantImagingFindings: 'significant_imaging_findings',
    PositiveCultures: 'positive_cultures',
    FallsAndMobility: 'falls_and_mobility',
    Other: 'other_pertinent',
};
//# sourceMappingURL=types.js.map